import { ITEM_OPTIONS, USER_OPTIONS } from "../../config/constants.js";
import { ItemsViewUserInfo } from "./view.js";

export class ItemsModel {
  loadAll() {
    return new Promise(async (resolve, reject) => {
      let productos = await this.load('producto');
      let inmuebles = await this.load('inmueble');
      let servicios = await this.load('servicio');
      let maquinas = await this.load('maquina');
      let items = [...productos, ...inmuebles, ...servicios, ...maquinas];
      // items = await this._prepareResults(items);

      resolve(items);
    });
  }

  async load(_entity) {
    return new Promise(async (resolve, reject) => {
      APICRUD[_entity].Read()
        .then(_items => {
          for (let i = 0; i < _items.data.length; i++) {
            _items.data[i].entity = _entity;
          }
          return _items;
        })
        .then(this._processResults.bind(this))
        .then(resolve)
        .catch((_error) => {
          console.error(_error);
          reject([]);
        });
    });
  }

  search(_fields, _param, _order, _limit) {
    return new Promise(async (resolve, reject) => {
      let productos = await this._searchAll('producto', _fields, _param, _order, _limit);
      let inmuebles = await this._searchAll('inmueble', _fields, _param, _order, _limit);
      let servicios = await this._searchAll('servicio', _fields, _param, _order, _limit);
      let maquinas = await this._searchAll('maquina', _fields, _param, _order, _limit);
      let items = [...productos.data, ...inmuebles.data, ...servicios.data, ...maquinas.data];
      items = await this._prepareResults(items);
      if (items && items.length > 0) {
        resolve(items);
      } else {
        reject();
      }
    });
  }

  async _searchAll(_entity, _fields, _param, _order, _limit) {
    return await new Promise((resolve, reject) => {
      APICRUD[_entity].Search(_fields, _param, _order, _limit)
        .then(_items => {
          for (let i = 0; i < _items.data.length; i++) {
            _items.data[i].entity = _entity;
          }
          return _items;
        })
        // .then(this._processResults.bind(this))
        .then(resolve)
        .catch([])
    });
  }

  _processResults(_response) {
    return new Promise(async (resolve, reject) => {
      // if (_response && _response.message == 'OK' && _response.data?.length > 0) {
      if (_response && _response.message == 'OK') {
        let results = await this._prepareResults(_response.data);
        resolve(results);
      } else {
        reject(_response.message);
        console.warn(_response.message);
      }
    });
  }

  _sortByDateDesc(_items) {
    if (!_items) {
      throw new Error("No hay items para ordenar.");
    }
    return _items.sort((a, b) => {
      const fechaA = new Date(a.dateCreate);
      const fechaB = new Date(b.dateCreate);
      return fechaB - fechaA;
    });
  }

  async _prepareResults(_data) {
    _data = this._sortByDateDesc(_data);
    let promises = _data.map(await this._prepareItem);
    let result = await Promise.all(promises);
    return result;
  }

  async _prepareItem(_item) {
    return await new Promise(async (resolve, reject) => {
      let images = _item.imagenes;
      if (images && typeof images == 'string' && images.length > 0) {
        try {
          images = JSON.parse(images);
        } catch (error) {
          console.log(error)
        }
      }
      if (!Array.isArray(images)) {
        images = [];
      }

      _item = app.itemsController.model.getTypes(_item);
      _item.resumen = FormatDescription(_item.resumen);
      _item.descripcion = FormatDescription(_item.descripcion);
      _item.maquinas = FormatDescription(_item.maquinas);
      _item.software = FormatDescription(_item.software);
      _item.fecha = APICRUD.Common.ConvertDateToSpanishShort(_item.dateUpdate || _item.dateCreate, false);

      let city = '';
      if (_item.localidad && _item.localidad != '0') {
        city = await APICRUD.Location.GetCityFromId(_item.localidad);
      }
      let state = '';
      if (_item.provincia && _item.provincia != '0') {
        state = await APICRUD.Location.GetStateFromId(_item.provincia);
      }

      if (city && state) {
        city = city.nombre + ', ' + state.nombre;
      }

      // let user = await app.userPrivateController.auth.getInfoUserFromIdcod(_item.idcodUserCreate);
      // user.occupation = USER_OPTIONS.Cargos.find(i => i.value == user.occupation)?.text || '';
      new ItemsViewUserInfo(_item.idcodUserCreate, _item.titulo, _item.user_deleted);

      // _item.user = user;
      _item.user = {};
      _item.radio = ITEM_OPTIONS.RadiosDeAccion.find(i => i.value == _item['radio-de-accion'])?.text || '';
      _item.city = city;
      _item.state = state;

      resolve(_item);
    });
  }

  async GetItem(_idcod, _entity) {
    return await new Promise((resolve, reject) => {
      APICRUD[_entity].Read(_idcod)
        .then(response => {
          if (response.message == 'OK') {
            return response.data;
          }
        })
        .then(this._prepareItem)
        .then(resolve)
        .catch(reject)
    });
  }

  getTypes(_item) {
    if (_item.tipo == "1" || _item.entity == 'producto') {
      _item.tipo = {
        urlBase: 'productos',
        singular: 'Producto',
        plural: 'Productos',
      }
      _item.nombreCategoria = ITEM_OPTIONS.Categorias.Productos.find(i => i.value == _item.categoria)?.text || '';

    } else if (_item.tipo == "2" || _item.entity == 'maquina') {
      _item.tipo = {
        urlBase: 'maquinaria',
        singular: 'Máquina',
        plural: 'Máquinas',
      }
      _item.nombreCategoria = ITEM_OPTIONS.Categorias.Maquinaria.find(i => i.value == _item.categoria)?.text || '';

    } else if (_item.tipo == "3" || _item.entity == 'inmueble') {
      _item.tipo = {
        urlBase: 'inmuebles',
        singular: 'Inmueble',
        plural: 'Inmuebles',
      }
      _item.nombreCategoria = ITEM_OPTIONS.Categorias.Inmuebles.find(i => i.value == _item.categoria)?.text || '';

    } else if (_item.tipo == "4" || _item.entity == 'servicio') {
      _item.tipo = {
        urlBase: 'servicios',
        singular: 'Servicio',
        plural: 'Servicios',
      }
      _item.nombreCategoria = ITEM_OPTIONS.Categorias.Servicios.find(i => i.value == _item.categoria)?.text || '';
    }
    return _item;
  }
}

const regexHr = /-{3,}/g;
const regexNegrita = /^[A-Z\s.,!?\'"()&]+$/gm;
const regexUrl = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
export function FormatDescription(_data) {
  if (_data && typeof _data == 'string') {
    return _data
      .replace(regexHr, '<hr>')
      .replace(regexNegrita, (match) => {
        return `<b>${match}</b>`;
      })
      .replace(regexUrl, (url) => {
        let link = url.startsWith("http") ? url : `http://${url}`;
        return `<a href="${link}" target="_blank">${url}</a>`;
      });
  }
  return '';
}
